import { render, staticRenderFns } from "./RegisterKlinik.vue?vue&type=template&id=f683a488&scoped=true&"
import script from "./RegisterKlinik.vue?vue&type=script&lang=js&"
export * from "./RegisterKlinik.vue?vue&type=script&lang=js&"
import style0 from "./RegisterKlinik.vue?vue&type=style&index=0&id=f683a488&scoped=true&lang=css&"
import style1 from "./RegisterKlinik.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f683a488",
  null
  
)

export default component.exports